import { useStaticImageQuery } from '~/queries/UseStaticImage.query';
import type { UseStaticImageQueryResult } from '~/sanity/types';

const imageNames = [
  'view-all',
  'education',
  'check',
  'filter-cta',
  'globe',
  'info',
  'right-arrow',
  'star45',
  'star5',
  'arrow',
  'done',
  'sign-in-arrow',
  'default-user',
  'recommended',
  'apple-touch-icon',
  'customer-home-texture',
  'search-icon',
  'search',
  'close',
] as const;

type StaticImageName = (typeof imageNames)[number];

export const useStaticImage = async (
  imageName: StaticImageName
): Promise<StaticAssetInfo | null> => {
  if (!imageNames.includes(imageName)) {
    console.error('Invalid static image name:', imageName);
    return null;
  }

  const currentPathname = `/static-images/${imageName}`;
  const { data } = await useWwwSanityQuery<UseStaticImageQueryResult>(useStaticImageQuery, {
    currentPathname,
  });

  if (!data.value) {
    console.error('No static asset found for pathname:', currentPathname);
    return null;
  }
  if (!data.value.cdnKey) {
    console.error('No CDN key found for static asset:', data.value);
    return null;
  }

  const imageRef = data.value.cdnKey;
  const bits = imageRef.split('-');
  if (bits.length < 3) {
    console.warn('Invalid CDN file reference:', imageRef);
    return null;
  }
  const fileExtension = bits.pop();
  bits.shift();
  const fileName = bits.join('-');
  const cdnPathname = `/cdn-images/${fileName}.${fileExtension}`;
  const tmpUrl = new URL(cdnPathname, 'https://www.onshape.com');

  return {
    ...data.value,
    cdnPathname: tmpUrl.pathname + tmpUrl.search,
    currentPathname,
  };
};
